import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import load_svg from '../../../assets/img/SVG_icons/Right/import-export/open.svg';
import { img } from '@phi/components';
import UploadTooltip from './UploadTooltip';

export const UploadIcon = load_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Load a file';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                this.state.modal.selectModelModal = true;
        },
    },

    render() {
        return h(BarButton, {
            id: 'upload-button',
            tippy: 'right',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 12,
            disabled: this.disabled,
            help: 'add_model',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(load_svg, this.alt),
            tooltip: UploadTooltip,
        });
    },
});
